import { all } from '@awesome.me/kit-fe73553903/icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import '@konova/ui/theme.scss';
import 'core-js/features/string/repeat';
import 'core-js/features/string/replace';
import 'core-js/modules/es.promise';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import './app.scss';
import { Main } from './components/Main/index.tsx';
import './custom-theme-styles/custom.scss';
import './feature/theme/_theme.css';
import './i18n.ts';
import { unregister } from './registerServiceWorker';

library.add(all);

const root = document.getElementById('root')!;

const router = createBrowserRouter([
  {
    path: '/:lang?/*',
    element: <Main />,
  }
], {
  future: {
    v7_relativeSplatPath: true,
    v7_startTransition: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,

  }
});
router.subscribe(state => {
  console.info('RTR', state.location.pathname, state.location.search, state.location.hash, state.location.state);
});


const appRoot = createRoot(root);
appRoot.render(<RouterProvider router={router} />);

unregister();
// registerServiceWorker();

navigator.serviceWorker?.getRegistrations().then(function (registrations) {
  for (const registration of registrations) {
    registration.unregister();
  }
});